"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = require("@jsluna/grid");

var _form = require("@jsluna/form");

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Rating = function Rating(_ref) {
  var id = _ref.id,
      ratingOptions = _ref.ratingOptions,
      disabled = _ref.disabled,
      value = _ref.value,
      setValue = _ref.setValue,
      error = _ref.error;
  var options = Array.from(Array(ratingOptions).keys()).map(function (x, i) {
    return {
      value: i + 1,
      label: i + 1,
      checked: i + 1 === parseInt(value)
    };
  });

  var handleSetValue = function handleSetValue(val) {
    return setValue(val);
  };

  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    GridItem: true,
    size: "1/2",
    className: "ln-u-text-align-left " + (disabled ? 'ln-u-color-grey-50' : '')
  }, "Strongly disagree"), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    GridItem: true,
    size: "1/2",
    className: "ln-u-text-align-right " + (disabled ? 'ln-u-color-grey-50' : '')
  }, "Strongly agree"), options.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/" + ratingOptions,
      key: id + "-" + x.value + "-RatingResponse"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ln-c-form-group ln-u-flush-bottom " + (error ? 'has-error' : '')
    }, /*#__PURE__*/_react.default.createElement(_form.RadioButton, {
      checked: x.checked,
      label: x.label,
      value: x.value,
      onChange: function onChange(e) {
        return handleSetValue(e.target.value);
      },
      disabled: disabled,
      fullWidth: true,
      name: id + "-" + x.value + "-RadioButton"
    })));
  }), error && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    error: error ? _constants.RATING_TYPE_ERROR : ''
  })));
};

Rating.propTypes = {
  /** The unique identifier of the question */
  id: _propTypes.default.string.isRequired,

  /** Indicates how many ratings are displayed */
  ratingOptions: _propTypes.default.number.isRequired,

  /** Indicates whether the component should be disabled */
  disabled: _propTypes.default.bool,

  /** The response value for this component */
  value: _propTypes.default.string,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the given response */
  error: _propTypes.default.bool
};
Rating.defaultProps = {
  disabled: false,
  value: '',
  setValue: function setValue() {},
  error: false
};
var _default = Rating;
exports.default = _default;